import {Ratecard} from '../admin-service.domain';

export type RateCardListValue = Ratecard | null
